import { useState, useRef, useEffect } from "react";
import { toast } from "react-toastify";
import "bootstrap/dist/css/bootstrap.min.css";
import {
  icon_normal,
  kirkos_logo_white_yellow,
  car_sign_in,
} from "../../assets/images";
// import CustomInput from "../../components/CustomInput";

import { useForm } from "react-hook-form";
// import rules from "../../rules";
import { useQueryClient, useQuery, useMutation } from "@tanstack/react-query";
import { trackEvent } from "../../services/events";
import axiosInstance from "../../services/axios.instance";
import { API_URL } from "../../services/apiConfig";
import { UserData, VerifyOtp } from "../../types";
import "./Customer_Otp_ViaForgot.css";
import "../Customer/signin/styles.css";
import "../Customer/signin/SignInScreen.css";
import { useLocation, useNavigate, Link } from "react-router-dom";

import SuccessModal from "../../components/SuccessModal";
import ErrorModal from "../../components/ErrorModal";
import { CustomerOnboardLeftSide } from "../../components";
import SEO from "../../components/SEO";
import DraggableWhatsAppIcon from "../../components/CustomerDashBoard/DraggableWhatsAppIcon";
const Customerotpviaforgot = () => {
  // const [showOtpscreen, setShowOtpscreen] = useState<boolean>(false);
  const [otp, setOtp] = useState<any>(["", "", "", ""]);
  const [otpRefs] = useState<any>([useRef(), useRef(), useRef(), useRef()]);
  const [isOtpVerified, setIsOtpVerified] = useState<boolean>(false);
  const { state } = useLocation();
  const phoneNo = state && state.phoneNo;
  const [transactionId, setTransactionId] = useState(sessionStorage.getItem("transactionId"));

  const [showSuccessModal, setShowSuccessModal] = useState(false);
  const [showErrorModal, setShowErrorModal] = useState(false);
  const [errorMessage, setErrorMessage] = useState("");
  const [resendTimer, setResendTimer] = useState(0);
  const [visibleIndices, setVisibleIndices] = useState<number[]>([]);

  useEffect(() => {
    let interval: any;
    if (resendTimer > 0) {
      interval = setInterval(() => {
        setResendTimer((prev) => prev - 1);
      }, 1000);
    } else if (resendTimer === 0) {
      clearInterval(interval);
    }
    return () => clearInterval(interval);
  }, [resendTimer]);

  const navigate = useNavigate();

  // Auto-focus first OTP input on page load
  useEffect(() => {
    if (otpRefs[0].current) {
      otpRefs[0].current.focus();
    }
  }, []);

  const handleOtpChange = (index: number, e: any) => {
    const value = e.target.value;

    // Only allow numeric input
    if (value && !/^\d+$/.test(value)) return;

    const newOtp = [...otp];
    // Use the last character to handle overwriting or multiple chars
    const char = value ? value.slice(-1) : "";
    newOtp[index] = char;
    setOtp(newOtp);

    if (char) {
      // Show digit for 0.3 seconds
      setVisibleIndices((prev) => [...prev, index]);
      setTimeout(() => {
        setVisibleIndices((prev) => prev.filter((i) => i !== index));
      }, 300);

      if (index < otpRefs.length - 1) {
        otpRefs[index + 1].current.focus();
      }
    }
  };

  const handleOtpKeyDown = (index: number, e: any) => {
    if (e.key === "Backspace") {
      if (!otp[index] && index > 0) {
        otpRefs[index - 1].current.focus();
      }
    }
  };

  const {
    control,
    handleSubmit,
    formState: { isValid },
    setValue,
    trigger,
  } = useForm({ mode: "onChange" });
  const handleOtpVerify = () => {
    const otpValue = otp.join("");
    if (otpValue.length < 4) {
      toast.error("Please enter the complete 4-digit verification code");
      return;
    }
    const payLoad: VerifyOtp = {
      phoneNo: phoneNo,
      transactionId,
      otp: otpValue,
      userType: "CONSUMER",
      event: "forgot_password",
    };
    verifyOtp.mutate(payLoad);
  };
  const verifyOtp = useMutation({
    mutationFn: (userData: VerifyOtp) =>
      axiosInstance.post(API_URL.VERIFY_OTP, userData),
    onSuccess: async (successResponse) => {
      await trackEvent({
        event_name: { web: "Kirkos_ForgetPassword_OTP_VerifySuccess", app: "Kirkos_ForgetPassword_OTP_VerifySuccess_App" },
        event_category: "SignIn",
        module: "Login",
        payload: {
          status: "success",
          message: successResponse?.data?.message ?? "",
        },
      });

      if (successResponse.status && successResponse?.data?.message) {
        setIsOtpVerified(true);
        // setShowSuccessModal(true);
        navigate("/newpassword", {
          state: { phoneNo: phoneNo, transactionId: transactionId, otp: otp.join("") },
        });
      }
    },
    onError: async (error: any) => {
      await trackEvent({
        event_name: { web: "Kirkos_ForgetPassword_OTP_VerifyFailed", app: "Kirkos_ForgetPassword_OTP_VerifyFailed_App" },
        event_category: "SignIn",
        module: "Login",
        payload: {
          status: "failed",
          message: error?.data?.message ?? error?.message ?? "Unknown error",
        },
      });

      if (error?.data?.message) {
        setErrorMessage(error?.data?.message);
        setShowErrorModal(true);
      } else {
        setErrorMessage("Otp Verification Failed");
        setShowErrorModal(true);
      }
    },
  });
  const handleResendOtp = () => {
    if (resendTimer > 0) return;

    const userData: UserData = {
      phoneNo: phoneNo,
      userType: "CONSUMER",
      event: "forgot_password",
    };

    resendOtp.mutate(userData);
    setResendTimer(30);
  };

  const resendOtp = useMutation({
    mutationFn: (userData: UserData) =>
      axiosInstance.post(API_URL.SEND_OTP, userData),
    onSuccess: (successResponse) => {
      if (successResponse.data && successResponse.data.transactionId) {
        const newTransactionId = successResponse.data.transactionId;
        setTransactionId(newTransactionId);
        sessionStorage.setItem("transactionId", newTransactionId);
        console.log("New Transaction ID:", newTransactionId);
      }
      if (successResponse.status && successResponse?.data?.message) {
        // setShowSuccessModal(true);
        console.log(successResponse?.data?.message)
      }
    },
    onError: (error: any) => {
      if (error?.data?.message) {
        setErrorMessage(error?.data?.message);
        setShowErrorModal(true);
      } else {
        setErrorMessage("Resend Otp Failed");
        setShowErrorModal(true);
      }
    },
  });
  return (
    <div className="customer-signin-page">
      <SEO
        title="Verify OTP | Kirkos Account Recovery"
        description="Verify your one-time password to recover your Kirkos account and reset your password."
        keywords="verify otp, account recovery, kirkos otp, secure verification"
      />
      <div className="customer-signin-shell">
        {/* Left Side: Brand Panel */}
        <div className="customer-signin-brand-panel">
          <div className="customer-signin-brand-topbar">
            <Link to="/" className="customer-signin-logo-link" aria-label="Kirkos home">
              <img
                src={kirkos_logo_white_yellow}
                alt="Kirkos"
                className="customer-signin-logo"
              />
            </Link>
            <div className="customer-signin-brand-links">
              <Link to="/" className="customer-signin-brand-link">
                Home
              </Link>
              <Link to="/signin" className="customer-signin-brand-link">
                Login
              </Link>
            </div>
          </div>

          <div className="customer-signin-brand-content">
            <span className="customer-signin-eyebrow">Verification</span>
            <h1 className="customer-signin-brand-title">
              Secure access to your journey
            </h1>
            <p className="customer-signin-brand-copy">
              We've sent a code to protect your account. Enter it to continue
              your premium Kirkos experience.
            </p>

            <div className="customer-signin-brand-highlights">
              <div className="customer-signin-highlight-card">
                <span className="customer-signin-highlight-value">Secure</span>
                <span className="customer-signin-highlight-label">
                  Multi-factor account protection
                </span>
              </div>
              <div className="customer-signin-highlight-card">
                <span className="customer-signin-highlight-value">Instant</span>
                <span className="customer-signin-highlight-label">
                  Real-time code delivery
                </span>
              </div>
              <div className="customer-signin-highlight-card">
                <span className="customer-signin-highlight-value">UAE</span>
                <span className="customer-signin-highlight-label">
                  Trusted mobility partner
                </span>
              </div>
            </div>

            <div className="customer-signin-car-stage">
              <div className="customer-signin-car-glow" />
              <img
                src={car_sign_in}
                className="customer-signin-car-image"
                alt="Kirkos premium rental car"
              />
            </div>
          </div>
        </div>

        {/* Right Side: OTP Card */}
        <div className="customer-signin-card">
          <div className="customer-signin-card-header">
            <div className="customer-signin-card-icon-wrap">
              <img
                src={icon_normal}
                className="customer-signin-card-icon"
                alt="Verification"
              />
            </div>
            <span className="customer-signin-card-kicker">Security</span>
            <h2 className="customer-signin-heading">OTP Verification</h2>
            <p className="customer-signin-subcopy">
              We have sent a one-time password to your registered phone number
              <span className="text-warning d-block mt-1">+971 {phoneNo}</span>
            </p>
            <div className="customer-signin-links-row">
              <span className="customer-signin-links-label">
                Remembered your password?
              </span>
              <Link to="/signin" className="customer-signin-inline-link">
                Login
              </Link>
            </div>
          </div>

          <div className="customer-signin-form-area">
            <div className="customer-signin-field-block">
              <label className="customer-signin-label">Enter Verification Code</label>
              <div className="customer_otp_grid_wrap mt-2">
                <div className="customer_otpContainerStyle_forgot">
                  {[0, 1, 2, 3].map((index) => (
                    <input
                      key={index}
                      type={visibleIndices.includes(index) ? "text" : "password"}
                      inputMode="numeric"
                      className="otpBoxStyle"
                      placeholder="0"
                      maxLength={1}
                      value={otp[index]}
                      onChange={(e) => handleOtpChange(index, e)}
                      onKeyDown={(e) => handleOtpKeyDown(index, e)}
                      onFocus={(e) => e.target.select()}
                      ref={otpRefs[index]}
                      autoComplete="off"
                    />
                  ))}
                </div>
              </div>
            </div>

            <button
              className="customer-signin-submit mt-3"
              onClick={handleOtpVerify}
            >
              VERIFY CODE
            </button>

            <div className="customer-signin-utility-row mt-3">
              <p className="customer-signin-utility-copy">
                Didn't receive the code?{" "}
                {resendTimer > 0 ? (
                  <span className="text-muted fw-bold ms-1">
                    RESEND IN {resendTimer}s
                  </span>
                ) : (
                  <span
                    className="customer-auth-secondary-link ms-1"
                    onClick={handleResendOtp}
                  >
                    RESEND
                  </span>
                )}
              </p>
            </div>

            <div className="customer-signin-support-strip">
              <span className="customer-signin-support-title">
                Verification issues?
              </span>
              <span className="customer-signin-support-copy">
                If you're having trouble receiving the code, please ensure your
                phone number is correct or contact Kirkos support.
              </span>
            </div>
          </div>
        </div>
      </div>
      <SuccessModal
        isOpen={showSuccessModal}
        onClose={() => setShowSuccessModal(false)}
        onNav={() => {
          if (verifyOtp.isSuccess) {
            navigate("/newpassword", {
              state: { phoneNo: phoneNo, transactionId: transactionId },
            });
          } else {
            setShowSuccessModal(false);
          }
        }}
        message={
          verifyOtp.isSuccess
            ? "Otp Verified Successfully"
            : "Otp Resent Successfully"
        }
      />
      <ErrorModal
        isOpen={showErrorModal}
        onClose={() => setShowErrorModal(false)}
        message={errorMessage}
      />
      <DraggableWhatsAppIcon />
    </div>
  );
};

export default Customerotpviaforgot;
